import React from 'react';
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';

// グラフを包むコンテナのスタイルを統一  
const ChartWrapper = styled.div`  
  background-color: #ffffff; /* 背景色を白に統一 */  
  border-radius: 15px; /* 角を丸く */  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 影を追加して浮かび上がるように */  
  padding: 20px; /* パディングを追加 */  
  flex: 1;  
  min-height: 400px; /* 最低限の高さを設定して詰まる問題を回避 */  
  max-height: 400px; /* 最大幅を指定して間延びを防ぐ */  
  @media (max-width: 768px) {  
    min-height: 300px; /* スマホではさらに高さを確保 */  
  }  
`;

const ChartsContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  padding: 0 20px 20px 20px;
  // width: 100%;  
  gap: 20px; /* カード間に適度な隙間を追加 */  
`;

const ChartComponent = ({ farmData }) => {
  const timestamps = farmData.data.timestamps.map(ts => {
    const date = new Date(ts * 1000);
    const dateString = date.toLocaleDateString('ja-JP', { month: 'numeric', day: 'numeric' });
    const timeString = date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' });
    return `${dateString} ${timeString}`;
  });

  const dataKeys = {
    'WRadInteg': '積算日射 (MJ/m²)',
    'InAirTempAve': '平均温度 (°C)',
    // 'InAirTemp': '温度 (°C)',   
    // 'InAirAbsHumid': '絶対湿度 (g/m³)',  
    'InAirHumid': '湿度 (%)',
    'InAirCO2': 'CO2濃度 (ppm)',
    'InAirDP': '露点温度 (°C)',
    'InAirHD': '湿度指数 (℃)',
    'InAirTempDay': '日中温度 (°C)',
    'InAirTempNgt': '夜間温度 (°C)',
    'MediumEC': '培地EC (mS/cm)',
    'MediumECAve': '平均培地EC (mS/cm)',
    'NrpH': 'pH',
    'NrpHAve': '平均pH',
    'WAirHumid': '外気湿度 (%)',
    'WAirTemp': '外気温度 (°C)',
    'WLUX': '照度 (lx)',
    'WRadiation': '放射量 (W/m²)',
    'WRainfall': '降雨量 (mm)',
    'WRainfallAmt': '降雨量総計 (mm)',
    // 'WWindDir16': '風向 (16方位)',  
    'WWindSpeed': '風速 (m/s)',
  };

  const generateRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const chartData = Object.keys(dataKeys).reduce((acc, key) => {
    if (farmData.data[key]) {
      acc[key] = {
        labels: timestamps,
        datasets: [{ label: dataKeys[key], data: farmData.data[key], fill: false, borderColor: generateRandomColor() }]
      };
    }
    return acc;
  }, {});

  const chartOptions = (titleText) => ({
    maintainAspectRatio: false,
    plugins: {
      legend: { labels: { color: 'black' } },
      background: { color: 'white' },
      datalabels: { display: false },
    },
    scales: {
      x: {
        grid: { color: 'rgba(0, 0, 0, 0.1)' },
        ticks: { color: 'black' },
      },
      y: {
        type: 'linear',
        position: 'left',
        grid: { color: 'rgba(0, 0, 0, 0.1)' },
        ticks: { color: 'black' },
        title: { display: true, text: titleText, color: 'black' },
      },
    },
  });

  return (
    <ChartsContainer>
      {Object.keys(chartData).map((key, index) => (
        <ChartWrapper key={index}>
          <Line data={chartData[key]} options={chartOptions(dataKeys[key])} />
        </ChartWrapper>
      ))}
    </ChartsContainer>
  );
};

export default ChartComponent;  
